import React from 'react';

interface Props {
  width?: number;
  height?: number;
}

export const Columns = ({ width = 66, height = 50 }: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 66 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x=".83"
      y=".5"
      width="29.63"
      height="49"
      rx="1.5"
      stroke="#333745"
      strokeDasharray="3 3"
    />
    <rect
      x="35.54"
      y=".5"
      width="29.63"
      height="49"
      rx="1.5"
      stroke="#333745"
      strokeDasharray="3 3"
    />
  </svg>
);
